import { PayloadAction } from '@reduxjs/toolkit';
import { GetProjectOptions, ProjectsReducerCreator } from '../types';

const setGetProjectOptionsReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Partial<GetProjectOptions>>) => {
    if (state.projectsLoading) return state;
    const options = Object.keys(action.payload) as (keyof GetProjectOptions)[];
    if (options.length === 1) {
      state.gettingProjectByOption = options[0];
    }
    state.getProjectsOptions = {
      ...state.getProjectsOptions,
      ...action.payload,
    };
  });
};

export default setGetProjectOptionsReducer;
